function update_atc_btn(active) {
  const btn = document.getElementById("atc_btn");

  if (!active) {
    btn.disabled = false;
    btn.classList.remove("disabled");
  } else {
    btn.disabled = true;
    btn.classList.add("disabled");
  }
}

function customRound(price, market_handle) {
    // Check if the market_handle is 'eu' or 'swiss'
    if (market_handle === 'eu' || market_handle === 'de' || market_handle === 'fr' || market_handle === 'nl' ) {

      if(price%1 != 0)
      // Round down to the nearest integer, then add 0.95
        return Math.floor(price) + 0.95;
      else
        return price;
        
    } 
    else {
        // Round up to the next whole number
        return Math.ceil(price);
    }
}


// function updateCAP(){
//   //debugger;
//   let price_format = formatMarketMoney(infinite_options.newPrice);

//   if(document.querySelector('.product-main-compare-price-span1') != null)
//   document.querySelector('.product-main-compare-price-span1').textContent = price_format;

// }

function adjustCurrencySymbolForCAP() {
   // Select the element
    const priceElement = document.querySelector(".product-main-compare-price-span1");
//debugger;
    if (priceElement) {
        // Get the text content of the element
        let priceText = priceElement.textContent.trim();

        // Check if the first character is the euro symbol (€)
        if (priceText.startsWith("€")) {
            // Separate the euro symbol and the numeric part
            const currencySymbol = priceText.charAt(0);
            const numericPart = priceText.slice(1).trim();

            // Reassign the adjusted price text to the element
            priceElement.textContent = `${numericPart}${currencySymbol}`;
        }
    }
}

function getSelectedOptions() {
  const selectedOptions = [];

  /* every variant block (new or old) carries data-js-product-variant */
  document.querySelectorAll('.product-variants [data-js-product-variant]')
    .forEach(block => {
      /* ---------- 1. grab the selection (radio first, then <select>) ---------- */
      const radio   = block.querySelector('input.product-variant__input:checked');
      const select  = block.querySelector('.selectopt_area .product-variant-container');

      let id, value;
      if (radio) {
        id    = radio.id;
        value = radio.value;
      } else if (select) {
        id    = select.id;
        value = select.options[select.selectedIndex].value;
      } else {
        return; // nothing to record
      }

      /* ---------- 2. derive optionNumber ---------- */
      const optClass = Array.from(block.classList).find(c => c.startsWith('varopt_'));
      // use the class if present (e.g. varopt_3 → option3), else fall back to index order
      const optionNumber = optClass ? optClass.replace('varopt_', 'option')
                                    : `option${selectedOptions.length + 1}`;

      selectedOptions.push({ id, value, optionNumber });
    });

  return selectedOptions;
}

function findMatchedVariant(variantsArray) {
  const selectedOptions = getSelectedOptions();
  
  const selectedValues = selectedOptions.map(option => option.value);

  const matchedVariant = variantsArray.find(variant => {

  const variantOptions = [variant.option1, variant.option2, variant.option3].filter(Boolean);
    
    return variantOptions.length === selectedValues.length && 
           variantOptions.every((option, index) => option === selectedValues[index]);
  });

  const result = matchedVariant || null;
  
  if (!result) update_atc_btn(true)
  else update_atc_btn(false)
  
  return result;
}

function parsePriceString(priceString) {
  const trimmedString = priceString.trim();

  const match = trimmedString.match(/([^\d.-]*)([\d.-]+)/);

  if (match) {
    const currencySign = match[1].trim();
    const price = parseFloat(match[2]);

    return [currencySign, price];
  }

  return null;
}
// dropdown price change 
function refreshInfinityOakDisplayPrices() {
  /* —— 1. Current totals —— */
  const sel          = (typeof collect_selecteds === "function") ? collect_selecteds() : {};
  const benchesTotal = (Array.isArray(sel?.benches) ? sel.benches : [])
    .reduce((sum, { price, qty }) =>
      sum + (Number(price) || 0) * (Number(qty) || 0), 0);

  const basePrice    = Number(infinite_options?.basePrice) || 0;
  const currentTotal = basePrice + benchesTotal;

  /* —— 2. Traverse every block / option —— */
  document.querySelectorAll(".infinity_oak_options").forEach(block => {
    block.querySelectorAll(".infinate-option").forEach(opt => {

      /* Read attributes */
      let priceVal = opt.dataset.priceValue;           // "12", 12, "0", …
      const byPct  = (opt.dataset.byPercentage || "").toLowerCase() === "true";

      /* Coerce to number (parseFloat fallback) */
      let priceNum = Number(priceVal);
      if (Number.isNaN(priceNum)) priceNum = parseFloat(priceVal);
      if (Number.isNaN(priceNum)) priceNum = 0;        // still invalid → treat as 0

      /* Calculate display price */
      let displayPrice = 0;
      if (byPct && priceNum !== 0) {
        displayPrice = (priceNum / 100) * currentTotal;
      } else {
        displayPrice = priceNum;
      }

      /* —— 3. Write attribute —— */
      if (displayPrice === 0) {
        opt.setAttribute("display-price", "");
      } else {
        const formatted = (typeof window.formatMarketMoney === "function")
          ? window.formatMarketMoney(displayPrice)
          : displayPrice.toFixed(2);

        opt.setAttribute("display-price", formatted);
      }
    });
  });
}
function updateDropDownListPriceAdditions(){
  debugger;
  const elements = document.querySelectorAll('.list_price'); // Replace with your selector

  // Convert NodeList to an array
  const elementsArray = Array.from(elements);

  elementsArray.forEach(el => {
    const priceArray = parsePriceString(el.parentElement.parentElement.getAttribute("data-price"));
    const byPercentage = el.parentElement.parentElement.getAttribute("data-by-percentage");
    
    if(byPercentage == "true"){
      const curr_var = findMatchedVariant(product_js.variants);
      const curr_var_price = curr_var.price / 100;
      const price = curr_var_price * parseFloat(priceArray[1]) / 100;

      // Format the price to 2 decimal places
      const text = priceArray[0] + customRound(price.toFixed(2), market_handle);
      el.textContent = text;
    }
    else {
      // Format the price array's second value to 2 decimal places
      const formattedPrice = customRound(parseFloat(priceArray[1]).toFixed(2), market_handle);
      el.textContent = priceArray[0] + formattedPrice;
    }
  });
}

// dropdown price change end 
// on change variant
function onChangeProductVariant(variants){
  const selectedVariant = findMatchedVariant(variants);
 // debugger;
  document.getElementsByClassName("id_input")[0].setAttribute("value", selectedVariant.id);

  const newBasePrice = parseFloat(selectedVariant.price/100).toFixed(2);
  infinite_options.updateBasePrice(newBasePrice);
  infinite_options.updateOptionsPricesByPercentage();
  // infinite_options.updateCAP();
  refreshInfinityOakDisplayPrices();
}

function onChangeAdditionalOptions(option, remove=false){
  //debugger;
  if(option.title == null) return false;
  if(option.price == null) return false;
  if(!remove)
    infinite_options.addOption(option.title, option.price, option.percentage, option.by_percentage, option.isBench, option.variantId, option.selectedTitle);
  else
    infinite_options.removeOption(option.title, option.isBench);
    // infinite_options.updateCAP();
}
function reformatPrice(price) {
  if (price.startsWith('€')) {
    return price.substring(1).trim() + " " +market_currency_symbol;
  } 
  else if (price.startsWith('CHF')) {
    return market_currency_symbol + " " + price.substring(3).trim();
  }
  else {
    return price;
  }
}
function updatePrice_main(newPrice) {
  // debugger;
  var priceElements = document.querySelectorAll('.product-main-price-span1');
  priceElements.forEach((priceElement) => {


    
    priceElement.textContent = reformatPrice(newPrice);

    priceElement.setAttribute('data-price', newPrice);
  });

  if (priceElements.length === 0) {
    console.error('Price elements not found');
  }
}

function getPriceWithoutCurrency_main() {
 // debugger;
  var priceElement = document.querySelector('.product-main-price-span1');
  if (priceElement) {
    var priceText = priceElement.getAttribute('data-price').trim();

    var price_sign = market_currency_symbol;
    
    var numericPrice = priceText.replace(/[^\d.-]/g, '');

    var priceNumber = parseFloat(numericPrice);

    return [price_sign, priceNumber];
  } else {
    console.error('Price element not found');
    return null;
  }
}


class CustomProduct {
  constructor(base_price, new_price, options) {
    this._custom_product = {
      base_price: base_price,
      new_price: new_price,
      options: options,
      added_options: []
    };
  }

  get basePrice() {
    return this._custom_product.base_price;
  }

  set basePrice(price) {
    this._custom_product.base_price = price;
    this.updateNewPrice();
  }

    reset_to_BasePrice(){
    this._custom_product.added_options = [];
    this._custom_product.new_price = this._custom_product.base_price;
  }


  updateBasePrice(newBasePrice) {
    this._custom_product.base_price = newBasePrice;
    setTimeout(()=> {
    console.log("This runs after 0.5 second.");
               this.updateNewPrice();
    // Your delayed code goes here
}, 300);
    
  }


  get addedOptions() {
    return this._custom_product.added_options;
  }

  set addedOptions(options) {
    this._custom_product.added_options = options;
    this.updateNewPrice();
  }

  addOption(title, price, percentage, by_percentage, isBench, variantId, selectedTitle) {
   // debugger;
    const existingOptionIndex = this._custom_product.added_options.findIndex(option => option.title === title && option.isBench == isBench);

    if (existingOptionIndex !== -1) {
      this._custom_product.added_options[existingOptionIndex].price = price;
      this._custom_product.added_options[existingOptionIndex].percentage = percentage;
      this._custom_product.added_options[existingOptionIndex].by_percentage = by_percentage;
      this._custom_product.added_options[existingOptionIndex].isBench = isBench;
      this._custom_product.added_options[existingOptionIndex].variantId = variantId;
      this._custom_product.added_options[existingOptionIndex].selectedTitle = selectedTitle;
    } else {
      this._custom_product.added_options.push({ title, price, percentage, by_percentage, isBench, variantId, selectedTitle });
    }

    this.updateNewPrice();
  }

  removeOption(title, isBench) {
    const optionIndex = this._custom_product.added_options.findIndex(option => option.title === title && option.isBench == isBench);

    if (optionIndex !== -1) {
      this._custom_product.added_options.splice(optionIndex, 1);
      this.updateNewPrice(); // Update the new price and UI after removal
    } else {
      console.error(`Option with title "${title}" not found.`);
    }
  }

  updateNewPrice() {
    //debugger;
    
    this.updateOptionsPricesByPercentage();
    
    const addedOptionsTotal = this._custom_product.added_options.reduce((total, option) => total + parseFloat(option.price), 0);
    this._custom_product.new_price = (parseFloat(this._custom_product.base_price) + parseFloat(addedOptionsTotal)).toFixed(2);

    const currencyInfo = getPriceWithoutCurrency_main();
    if (currencyInfo) {
      const [currencySign, _] = currencyInfo;
      if(currencySign == "€"){
      updatePrice_main(`${currencySign}${parseFloat(customRound(this._custom_product.new_price, market_handle)).toLocaleString("de-DE")}`);        
      }
      else{
      updatePrice_main(`${currencySign}${Math.round(parseFloat(customRound(this._custom_product.new_price, market_handle))).toLocaleString("en-US")}`);
      }
    }

adjustCurrencySymbolForCAP();
    this.updateCAP()
  
    
  }



updatePercentageByClass(capPrice, salePrice) {
    const elements = document.querySelectorAll('.off-text');

    // Safety: avoid division errors
    if (typeof capPrice !== "number" || typeof salePrice !== "number" || capPrice <= 0) {
        console.warn("Invalid CAP or sale price.");
        return;
    }

    // Calculate percentage difference
    const discountRatio = (capPrice - salePrice) / capPrice;
    const percentage = Math.round(discountRatio * 100);  // round to nearest whole %

    elements.forEach(el => {
        const originalHTML = el.innerHTML;

        // Replace only the number before the %
        const updatedHTML = originalHTML.replace(/(\b\d+)(?=\s*%)/, String(percentage));

        if (updatedHTML !== originalHTML) {
            el.innerHTML = updatedHTML;
        }
    });
}

  updateCAP () {
  const variant = findMatchedVariant(product_js.variants);
  if (!variant) return;

  const basePrice = Number(variant.price);             // £ → cents (int)
  const baseCap   = Number(variant.compare_at_price);  // £ → cents (int)
  if (!basePrice) return;                              // price == 0 or NaN? bail

  this.updatePercentageByClass(baseCap, basePrice);

  /* 2 ▸ markup ratio that already exists on the product (e.g. 0.20 = +20 %) */
  const markupRatio = (baseCap - basePrice) / basePrice;

  

  /* 3 ▸ latest “new price” coming from infinite_options (expecting **cents**) */
  const newPriceCents = window.toNumber(this._custom_product.new_price);
  if (Number.isNaN(newPriceCents)) return;

  /* 4 ▸ apply the same markup to get the new CAP */
  const newCapCents = Math.round(newPriceCents * (1 + markupRatio));

  /* 5 ▸ inject into UI & any hidden inputs you rely on */
  const spans = document.querySelectorAll('.product-main-compare-price-span1');
  spans.forEach(span => {
    span.textContent = window.formatMarketMoney(newCapCents);
  });

  const hiddenInputs = document.querySelectorAll('#custom_price');
  hiddenInputs.forEach(input => {
    input.value = newCapCents;
  });
}


  get newPrice() {
    return this._custom_product.new_price;
  }

  // New method to update prices in added options based on percentage of base price
updateOptionsPricesByPercentage() {
  // Sum only benches (options where isBench > 0)
  const benchesTotal = this._custom_product.added_options
    .filter(opt => Number(opt.isBench) > 0)
    .reduce((sum, opt) => sum + (parseFloat(opt.price) || 0), 0);

  // Base + benches total is the new reference for percentage calculations
  const basePlusBenches = (parseFloat(this._custom_product.base_price) || 0) + benchesTotal;

  this._custom_product.added_options.forEach(option => {
    if (option.percentage) {
      if (option.by_percentage == "true") {
        // Percentage of (base + benches only)
        option.price = customRound((basePlusBenches * (parseFloat(option.percentage) || 0)) / 100, market_handle).toFixed(2);
      } else {
        // Fixed amount
        option.price = option.percentage;
      }
    }
  });
  // This method intentionally does NOT call updateNewPrice() here
}
}

  

